var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"folioContainer"},[_vm._v("\n    Create or load a portfolio by entering a your portfolio key\n    "),_c('br'),_vm._v(" "),_c('v-btn',{staticStyle:{"background":"#C62E2E","color":"white"}},[_vm._v("New Portfolio")]),_vm._v(" "),_c('v-btn',{staticStyle:{"background":"#C62E2E","color":"white"}},[_vm._v("Import Portfolio")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68520616","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/Dynamic/app/CryptoFolio/main.vue
// module id = 490
// module chunks = 0